// config/authzPermissions.ts
import { Ability, AbilityBuilder } from "@casl/ability";

export type Actions = "create" | "read" | "update" | "delete" | "getAll" | "isSuperAdmin";
export type Modules =
  | "Planner" | "Routine" | "Profile" | "Dashboard" | "Teacher" | "Subject"
  | "Student" | "Mark" | "ExamSession" | "Class" | "Guardian" | "Absence"
  | "Task" | "Message" | "Expense" | "Fee" | "StudentFee" | "Instance"
  | "Document" | "UserManagement" | "SubjectCoefficients" | "AuditLog" | "SettingsInstance" | "Staff" | "Leave" | "Payroll" | "AuthorizedPickUpPerson" | "StudentExit" | "CashBox"
  | "all";

export type AppAbilities = [Actions, Modules];
export type AppAbility = Ability<AppAbilities>;               // 👈 use this everywhere

// keep this function as-is if you already have it; just ensure it returns AppAbility
export function buildAbilityFromPairs(
  pairs: { action: Actions; subject: Modules }[],
  isSuperAdmin = false
): AppAbility {
  const { can, build } = new AbilityBuilder<AppAbility>(Ability as any);

  if (isSuperAdmin) {
    can("isSuperAdmin", "all");
    return build();
  }

  const seen = new Set<string>();
  for (const p of pairs || []) {
    const key = `${p.action}::${p.subject}`;
    if (!seen.has(key)) {
      seen.add(key);
      can(p.action, p.subject);
    }
  }
  return build();
}

// helper for a default empty ability (avoids importing Ability in other files)
export const createEmptyAbility = (): AppAbility => new Ability<AppAbilities>() as AppAbility;
